import { render, staticRenderFns } from "./DataGrade.vue?vue&type=template&id=7ae47754"
import script from "./DataGrade.vue?vue&type=script&lang=js"
export * from "./DataGrade.vue?vue&type=script&lang=js"
import style0 from "./DataGrade.vue?vue&type=style&index=0&id=7ae47754&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports